/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import {
  Container,
  Grid,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  CardHeader,
  Box,
  Divider,
} from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import IconButton from '@mui/material/IconButton';
import ReplayIcon from '@mui/icons-material/Replay';
import axiosInstance from '../../utils/axiosInstance';

const CameraList = ({ successList, failureList, onRetry }) => (
  <Box>
    <Typography variant="h5">Status</Typography>
    <Divider sx={{ my: 2 }} />
    {successList.length > 0 && (
      <>
        <Typography variant="h6">{`Successful (${successList.length}):`}</Typography>
        <Box sx={{ m: 3 }}>
          <ul>
            {successList.map((camera) => (
              <li key={camera.sensorUrl} style={{ color: 'green' }}>
                {camera.sensorUrl}
              </li>
            ))}
          </ul>
        </Box>
      </>
    )}
    {failureList.length > 0 && (
      <>
        <Box display="flex" alignItems="center">
          <Typography variant="h6">{`Failed (${failureList.length}):`}</Typography>
          <IconButton aria-label="delete" size="small" onClick={onRetry}>
            <ReplayIcon fontSize="small" />
          </IconButton>
        </Box>

        <Box sx={{ m: 3 }}>
          <ul>
            {failureList.map((camera) => (
              <li key={camera.sensorUrl} style={{ color: 'red' }}>
                {camera.sensorUrl}
              </li>
            ))}
          </ul>
        </Box>
      </>
    )}
  </Box>
);

const UrlInput = () => {
  const [url, setUrl] = React.useState('');
  const [liveUrlList, setLiveUrlList] = React.useState([]);
  const [successfulCameras, setSuccessfulCameras] = React.useState([]);
  const [failedCameras, setFailedCameras] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const fetchNewList = async () => {
      setTimeout(() => {
        const refreshListButton = document.getElementById('refresh-list-button');
        if (refreshListButton) {
          refreshListButton.click();
        }
      }, 1000);
    };
    if (liveUrlList.length > 0) {
      setLoading(true);
    }
    for (let i = 0; i < liveUrlList.length; i += 1) {
      const lastSegment = liveUrlList[i]
        .split('/')
        .filter((segment) => segment !== '')
        .pop();
      const cameraName = lastSegment ? lastSegment.split('.')[0] : 'RTSP';
      console.log(cameraName);
      const jsonData = {
        name: cameraName,
        sensorUrl: liveUrlList[i],
      };
      axiosInstance
        .post(`${window.location.protocol}//${window.location.host}/api/v1/sensor/add`, jsonData)
        .then(() => {
          if (i === liveUrlList.length - 1) {
            setLoading(false);
            fetchNewList();
          }
          setSuccessfulCameras((prevState) => [...prevState, jsonData]);
        })
        .catch((error) => {
          if (i === liveUrlList.length - 1) {
            setLoading(false);
            fetchNewList();
          }
          setFailedCameras((prevState) => [...prevState, jsonData]);
          if (error.response.data == null)
            enqueueSnackbar(`Error failed to add ${jsonData.url} - ${error.response.status}`, {
              variant: 'error',
              anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
            });
          else
            enqueueSnackbar(`Error failed to add ${jsonData.url} - ${error.response.data.error_message}`, {
              variant: 'error',
              anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
            });
        });
    }
  }, [liveUrlList]);

  const onRetry = () => {
    setLiveUrlList([]);
    setSuccessfulCameras([]);
    setFailedCameras([]);
    setTimeout(() => {
      const temp = [];
      console.log('failedCameras: ', failedCameras);
      failedCameras.forEach((camera) => {
        temp.push(camera.sensorUrl);
      });
      console.log('retry list: ', temp);
      setLiveUrlList(temp);
    }, 200);
  };

  const handleSubmit = (e) => {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      enqueueSnackbar(`Entered invalid URL`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      return;
    }
    setLoading(true);
    setSuccessfulCameras([]);
    setFailedCameras([]);
    e.preventDefault();
    axiosInstance
      .get(`${url}/api/v1/sensor/streams`)
      .then((response) => {
        if (response.data) {
          const liveUrls = [];
          response.data.forEach((camera) => {
            const liveUrl = camera[Object.keys(camera)[0]].find((stream) => stream.isMain).url;
            liveUrls.push(liveUrl);
          });
          console.log('live  URLs: ', liveUrls);
          setLoading(false);
          setLiveUrlList(liveUrls);
        }
      })
      .catch((e) => {
        setLoading(false);
        console.error('get device streams error', e);
        enqueueSnackbar(`Failed to get streams from ${url}`, {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      });
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4 }}>
      <Typography variant="h4" sx={{ mb: 5 }}>
        Add streams
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card variant="outlined">
            <CardHeader
              title={'Enter endpoint to fetch streams'}
              subheader={'Supported format: http://ip:port or https://ip:port'}
            />
            <CardContent>
              <form onSubmit={handleSubmit}>
                <TextField
                  label="URL"
                  fullWidth
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                  variant="outlined"
                />
                <Button variant="contained" color="primary" sx={{ mt: 2 }} type="submit">
                  Submit
                </Button>
              </form>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              {loading && (
                <Box sx={{ width: '100%' }}>
                  <LinearProgress />
                </Box>
              )}
              {liveUrlList.length > 0 && (
                <CameraList successList={successfulCameras} failureList={failedCameras} onRetry={onRetry} />
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default UrlInput;
